package one.healthium.domain.user.models

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class PeriodLogModel(
    val periods: List<Instant> = emptyList()
)